import React from "react";
import PropTypes from "prop-types";

import { withStyles } from "material-ui/styles";
import Typography from "material-ui/Typography";
import Button from "../../Parts/Button";

import DialogModal from "../../common/DialogModal";
import { addCommas } from "../../../utils/utils";

const styles = () => ({
  text: {
    margin: "25px 0px 40px 0px",
    textAlign: "left",
  },

  button: {
    background: "#F03A47",
    "&:hover::before": {
      backgroundColor: "#F03A47",
      opacity: 0.6,
    },
  },

  contentContainer: {
    padding: "50px 40px",
    margin: 0,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "650px",
    boxSizing: "border-box",
    background: "#FFFFFF",
  },

  textContainer: {
    marginTop: "24px",
    width: "520px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
  },

  buttonContainer: {
    display: "inline-flex",
    width: "100%",
    justifyContent: "center",
  },
});

class SalesforceInfoBox extends React.Component {
  render() {
    const { classes, isOpen, toggleDialog } = this.props;

    return (
      <DialogModal
        open={isOpen}
        onClose={toggleDialog}
        aria-labelledby="pop-up-window"
        maxWidth={false}
        classes={{
          contentContainer: classes.contentContainer,
        }}
      >
        <img
          alt="salesforce"
          src={require("../../../assets/images/salesforce-integration@2x.png")}
          height="300"
        />

        <div className={classes.textContainer}>
          <Typography variant="title" style={{ fontWeight: "bold" }}>
            Salesforceリストがご利用できます
          </Typography>
          <Typography variant="subheading" className={classes.text}>
            {addCommas(this.props.syncCount)}
            件がメインボックスに同期されています。レコード情報の編集は、Salesforce上で行ってください（同期時にKeyman
            Letter側にも反映されます）。編集内容は手動で同期されます。
          </Typography>
        </div>

        <div className={classes.buttonContainer}>
          <Button handleClickButton={toggleDialog} text="OK"></Button>
        </div>
      </DialogModal>
    );
  }
}

SalesforceInfoBox.propTypes = {
  classes: PropTypes.object.isRequired,
  toggleDialog: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  syncCount: PropTypes.number,
};

export default withStyles(styles)(SalesforceInfoBox);



// WEBPACK FOOTER //
// ./src/components/AddressBook/dialogs/SalesforceInfoBox.jsx